import {GlobalStyle} from "./styles/global"


function App() {
  return (
    <div className="App">
        <GlobalStyle/>
    </div>
  );
}

export default App;
